//
// Module for Recalc Benefit Differences Step Adjustments (partial view) displayed within common Recalc Benefit Differences Step in Benefit Setup wizards
//
rs.module("participant/benefit/setup/common/wizard/recalcbenefitdifferencestepadjustments",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, variables, modes, backendUrls) {

            // get JS selectors
            var stepAdjustmentsContainer = $.js(jsSelectors.stepAdjustmentsContainer);
            var addLink = stepAdjustmentsContainer.js(jsSelectors.addLink, { required: false });
            var adjustmentSelect = stepAdjustmentsContainer.js(jsSelectors.adjustmentSelect, { required: false });
            var applyPriorToTaxCheckbox = stepAdjustmentsContainer.js(jsSelectors.applyPriorToTaxCheckbox, { required: false });
            var applyTaxExclusionCheckbox = stepAdjustmentsContainer.js(jsSelectors.applyTaxExclusionCheckbox, { required: false });
            var saveButton = stepAdjustmentsContainer.js(jsSelectors.saveButton, { required: false });
            var cancelButton = stepAdjustmentsContainer.js(jsSelectors.cancelButton, { required: false });

            // Get the form (this will be the wizard form)
            var _form = stepAdjustmentsContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // Get the wizard's next and back buttons for enabling/disabling 
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            var wizardBackButton = $(`[data-wizard]`).js("_back");

            // Hookup adjustmentSelect change event
            adjustmentSelect.change(adjustmentChanged);

            // Adjustment selection changed
            function adjustmentChanged() {

                // Get the key of the selected adjustment (available pay component)
                var selectedAvailablePayComponentKey = adjustmentSelect.val();

                // Default the applyPriorToTax and applyTaxExclusion based on the selected adjustment's properties
                $.get(backendUrls.getAvailablePayComponentProperties,
                    {
                        availablePayComponentKey: selectedAvailablePayComponentKey
                    })
                    .done(function (data) {
                        applyPriorToTaxCheckbox.prop('checked', data.applyPriorToTax);
                        applyTaxExclusionCheckbox.prop('checked', data.applyTaxExclusion);
                    });
            }
  
            // addLink click handler
            addLink.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                $.get(backendUrls.getRecalcBenefitDifferenceStepAdjustments,
                    {
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        mode: modes.add,
                        canAddRecalcAdjustment: variables.canAddRecalcAdjustment
                    })
                    .done(function (html) {
                        stepAdjustmentsContainer.parent().html(html);
                        wizardNextButton.setDisabled();
                        wizardBackButton.setDisabled();
                    });
            });

            // cancelButton click handler
            cancelButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                $.get(backendUrls.getRecalcBenefitDifferenceStepAdjustments,
                    {
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        mode: modes.view,
                        canAddRecalcAdjustment: variables.canAddRecalcAdjustment
                    })
                    .done(function (html) {
                        stepAdjustmentsContainer.parent().html(html);
                        wizardNextButton.setDisabled(false);
                        wizardBackButton.setDisabled(false);
                    });
            });

            // saveButton click handler
            saveButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                if (_form.valid()) {
                    $.post(                        
                        {
                            url: backendUrls.saveRecalcAdjustment,
                            data: new FormData(_form[0]),
                            contentType: false,
                            cache: false,
                            processData:false
                        }
                    ).done(function (html, status, xhr) {

                        // Populate the parent container with the returned partial view
                        stepAdjustmentsContainer.parent().html(html);

                        // If successful, re-enable wizard buttons
                        if (xhr.rsMessages == null || (xhr.rsMessages != null && xhr.rsMessages.ModelStateErrors.length == 0)) {
                            wizardNextButton.setDisabled(false);
                            wizardBackButton.setDisabled(false);
                        }
                    });
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);